var _ = require('lodash');

var input_types = {
	captcha: require('./inputs/Captcha'),
	checkbox: require('./inputs/Checkbox'),
	combo: require('./inputs/Combo'),
	date: require('./inputs/Date/index'),
	esBudgetRange: require('./inputs/esBudgetRange'),
	esCountry: require('./inputs/esCountry'),
	esState: require('./inputs/esState'),
	file: require('./inputs/File'),
	select: require('./inputs/Select'),
	static: require('./inputs/Static'),
	text: require('./inputs/Text'),
	textarea: require('./inputs/Textarea')
};

var getInputByType = function(type){
	if(!_.has(input_types, type)){
		type = 'text';
	}
	return input_types[type];
};

var setInputType = function(type, input){
	input_types[type] = input;
};

module.exports = {
	getInputByType: getInputByType,
	setInputType: setInputType
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/forms/InputTypes.js
// module id = 190
// module chunks = 0 1 2 3 4